export const getDashboardType = dashboard => {
  if (dashboard?.hasPassword) {
    return 'Restricted'
  }

  if (dashboard?.isPublic) {
    return 'Public'
  }

  return 'Private'
}
